/* Non-purchasing enquiry state lives in a bounded Shopify cart attribute, never cart items. */
(function () {
  'use strict';
  const MAX_ITEMS = 25, MAX_QUANTITY = 999, LIMIT = 8000;
  const ATTRIBUTE = '_amp_enquiry_list_v2', PENDING = 'amp-enquiry-pending-v2';
  function quantity(value) {
    if (!/^[1-9][0-9]*$/.test(String(value)) || Number(value) > MAX_QUANTITY) throw Error('Enter a whole quantity from 1 to 999.');
    return Number(value);
  }
  function validate(items) {
    if (!Array.isArray(items) || items.length > MAX_ITEMS) throw Error('The enquiry list is invalid or too long. Contact us for help.');
    const ids = new Set();
    return items.map(raw => {
      if (!raw || !/^[0-9]{1,20}$/.test(String(raw.id)) || ids.has(String(raw.id))) throw Error('Invalid enquiry product.');
      ids.add(String(raw.id));
      const title = raw.title, sku = raw.sku, url = raw.url;
      if (typeof title !== 'string' || !title.trim() || title.length > 180 || /[\r\n\x00-\x1f]/.test(title) ||
          typeof sku !== 'string' || sku.length > 80 || /[\r\n\x00-\x1f]/.test(sku) ||
          typeof url !== 'string' || !/^\/products\/[a-z0-9][a-z0-9-]{0,220}$/.test(url)) throw Error('Invalid enquiry product details.');
      return {id:String(raw.id),title,sku,url,quantity:quantity(raw.quantity)};
    });
  }
  function serializeList(items) {
    const value = JSON.stringify({version:2,items:validate(items)});
    if (value.length > LIMIT) throw Error('The enquiry list is too long. Please contact us for help.');
    return value;
  }
  function parseList(value) {
    if (!value) return [];
    if (typeof value !== 'string' || value.length > LIMIT) throw Error('The enquiry list is invalid. Please contact us.');
    let data;
    try { data=JSON.parse(value); } catch (_) { throw Error('The enquiry list is invalid. Please contact us.'); }
    if (!data || data.version !== 2 || !Array.isArray(data.items)) throw Error('The enquiry list is invalid. Please contact us.');
    return validate(data.items);
  }
  function sameItems(a,b) { return serializeList(a) === serializeList(b); }
  function addItem(items, item) {
    const current=validate(items), next=validate([item])[0], match=current.find(x=>x.id===next.id);
    if (match) return validate(current.map(x=>x.id===next.id ? {...x,quantity:quantity(x.quantity+next.quantity)} : x));
    return validate([...current,next]);
  }
  function changeItem(items, id, value) {
    const current=validate(items);
    if (!current.some(x=>x.id===String(id))) throw Error('The product is no longer in the list.');
    return validate(value===0 ? current.filter(x=>x.id!==String(id)) : current.map(x=>x.id===String(id) ? {...x,quantity:quantity(value)} : x));
  }
  const BODY_LIMIT=12000;
  function cleanText(value, limit, label) {
    if(typeof value!=='string' || value.length>limit || /[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/.test(value)) throw Error(`${label} is too long or contains invalid characters.`);
    return value.replace(/\r\n?/g,'\n');
  }
  function formatEnquiry(items, message, origin='https://austmadepackaging.com.au', suburb='') {
    const checked=validate(items);
    if(!checked.length) throw Error('Add a product before sending an enquiry.');
    const note=cleanText(message,3500,'Your message'), place=cleanText(suburb,120,'Delivery suburb');
    if(/[\n\r]/.test(place)) throw Error('Enter the delivery suburb on one line.');
    const base=new URL(origin);
    if(!/^https?:$/.test(base.protocol)) throw Error('Invalid product URL origin.');
    const blocks=checked.map((x,i)=>`Item ${i+1}\nTitle: ${x.title}\nSKU: ${x.sku || 'not listed'}\nQuantity: ${x.quantity}\nURL: ${new URL(x.url,base.origin).href}`);
    const body=`Enquiry list (${checked.length} ${checked.length===1?'item':'items'}):\n\n${blocks.join('\n\n')}\n\nDelivery suburb: ${place || 'Not supplied'}\n\nCustomer message:\n${note.split('\n').map(line=>`  ${line}`).join('\n')}`;
    if(body.length>BODY_LIMIT) throw Error('The enquiry is too long. Please contact us directly.');
    return body;
  }
  function restoredDetails(value) {
    if(typeof value!=='string') return {message:'',suburb:''};
    const newer=/^Enquiry list \((\d+) items?\):\n\n([\s\S]*?)\n\nDelivery suburb: ([^\n]*)\n\nCustomer message:\n([\s\S]*)$/.exec(value);
    if(newer) {
      const blocks=newer[2].split('\n\n');
      if(Number(newer[1])===blocks.length && blocks.every((block,i)=>new RegExp(`^Item ${i+1}\\nTitle: [^\\n]+\\nSKU: [^\\n]*\\nQuantity: [1-9][0-9]*\\nURL: https?://[^\\n]+/products/[a-z0-9-]+$`).test(block)) && newer[4].split('\n').every(line=>line.startsWith('  '))) {
        return {message:newer[4].split('\n').map(line=>line.slice(2)).join('\n'),suburb:newer[3]==='Not supplied'?'':newer[3]};
      }
    }
    const older=/^Enquiry list \(([0-9]+) items?\):\n([\s\S]*?)\n\nYour message:\n([\s\S]*)$/.exec(value);
    if(older && Number(older[1])===older[2].split('\n').length && older[2].split('\n').every(line=>/^\d+\. .+ \| SKU .+ \| Quantity [1-9][0-9]* \| https?:\/\/[^\s]+\/products\/[a-z0-9-]+$/.test(line))) return {message:older[3],suburb:''};
    return {message:value,suburb:''};
  }
  function originalMessage(value) {return restoredDetails(value).message;}
  if (typeof module !== 'undefined' && module.exports) module.exports={parseList,serializeList,addItem,changeItem,formatEnquiry,sameItems,quantity,MAX_ITEMS,originalMessage,restoredDetails};
  if (typeof document === 'undefined') return;
  const root=document.querySelector('[data-amp-enquiry]'), counters=[...document.querySelectorAll('[data-enquiry-count]')];
  const drawer=document.querySelector('[data-enquiry-drawer]'), opener=document.querySelector('[data-enquiry-opener]');
  let items=[], ready=false, busy=false, sending=false, readVersion=0;
  const status=root?.querySelector('[data-enquiry-status]');
  const announce=(text,error=false)=>{if(status){status.textContent=text;status.classList.toggle('amp-enquiry-error',error);}};
  async function api(value) {
    const response=await fetch(`${window.Shopify?.routes?.root || '/'}${value===undefined?'cart.js':'cart/update.js'}`,{
      method:value===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',
      headers:value===undefined?{}:{'Content-Type':'application/json'},
      body:value===undefined?undefined:JSON.stringify({attributes:{[ATTRIBUTE]:value}})
    });
    if (!response.ok) throw Error('The enquiry list could not be saved. Please use the contact form instead.');
    return response.json();
  }
  const read=async()=>parseList((await api()).attributes?.[ATTRIBUTE]);
  function renderDrawer() {
    if(!drawer||!drawer.open)return;
    const list=drawer.querySelector('[data-enquiry-drawer-items]');list.replaceChildren();
    const status=drawer.querySelector('[data-enquiry-drawer-status]');
    const retry=drawer.querySelector('[data-enquiry-drawer-retry]');
    const empty=drawer.querySelector('[data-enquiry-drawer-empty]');
    const review=drawer.querySelector('[data-enquiry-drawer-review]');
    drawer.querySelector('[data-enquiry-drawer-count]').textContent=ready?`(${items.length})`:'';
    empty.hidden=!ready||items.length>0;
    review.hidden=!ready||!items.length||busy;
    if(!ready||busy)return;
    retry.hidden=true;status.textContent='';
    for(const item of items){
      const li=document.createElement('li');li.className='amp-enquiry-drawer__item';
      const link=document.createElement('a');link.href=item.url;link.textContent=item.title;li.append(link);
      if(item.sku){const sku=document.createElement('span');sku.textContent=`SKU ${item.sku}`;li.append(sku);}
      const qty=document.createElement('span');qty.textContent=`Quantity ${item.quantity}`;li.append(qty);
      list.append(li);
    }
  }
  function render() {
    for(const counter of counters) counter.textContent=ready?String(items.length):'–';
    if(opener)opener.setAttribute('aria-label',ready?`Enquiry list, ${items.length} ${items.length===1?'product':'products'}`:'Enquiry list, unavailable');
    renderDrawer();
    if(!root) return;
    const list=root.querySelector('[data-enquiry-items]');
    if(list){
      list.replaceChildren();
      for(const item of items){
        const li=document.createElement('li');li.className='amp-enquiry-item';
        const link=document.createElement('a');link.className='amp-enquiry-item__title';link.href=item.url;link.textContent=item.title;li.append(link);
        const detail=document.createElement('span');detail.className='amp-enquiry-item__sku';detail.textContent=`SKU ${item.sku||'not listed'}`;li.append(detail);
        const controls=document.createElement('div');controls.className='amp-enquiry-item__controls';
        const label=document.createElement('label');label.textContent='Quantity ';
        const input=document.createElement('input');input.type='number';input.min='1';input.max=String(MAX_QUANTITY);input.step='1';input.value=String(item.quantity);input.setAttribute('aria-label',`Quantity for ${item.title}`);label.append(input);controls.append(label);
        const update=document.createElement('button');update.type='button';update.textContent='Update';update.setAttribute('aria-label',`Update quantity for ${item.title}`);update.addEventListener('click',()=>{if(!input.reportValidity())return;mutate(current=>changeItem(current,item.id,input.value));});controls.append(update);
        const remove=document.createElement('button');remove.type='button';remove.textContent='Remove';remove.setAttribute('aria-label',`Remove ${item.title}`);remove.addEventListener('click',()=>mutate(current=>changeItem(current,item.id,0)));controls.append(remove);
        for(const control of [input,update,remove]) control.disabled=busy||sending;
        li.append(controls);list.append(li);
      }
      root.querySelector('[data-enquiry-empty]').hidden=items.length>0;
      root.querySelector('[data-enquiry-review]').hidden=items.length===0;
      root.querySelector('[data-enquiry-fields]').hidden=!ready||items.length===0;
      const send=root.querySelector('[data-enquiry-send]');send.disabled=!ready||!items.length||busy||sending;
      const bodyField=root.querySelector('[data-enquiry-body]');bodyField.value='';
    }
  }
  async function refresh() {
    const version=++readVersion;
    try{
      const fresh=await read();if(version!==readVersion)return false;
      items=fresh;ready=true;render();if(status?.textContent==='Loading your enquiry list…')announce('');return true;
    }catch(e){
      if(version!==readVersion)return false;
      items=[];ready=false;render();announce(`${e.message} Your list was not changed.`,true);
      if(drawer?.open){drawer.querySelector('[data-enquiry-drawer-status]').textContent='Could not load your enquiry list. Try again or open the full list.';drawer.querySelector('[data-enquiry-drawer-retry]').hidden=false;}
      return false;
    }
  }
  if(drawer&&opener&&typeof drawer.showModal==='function'){
    const loadDrawer=()=>{
      items=[];ready=false;render();
      drawer.querySelector('[data-enquiry-drawer-status]').textContent='Loading your enquiry list…';
      drawer.querySelector('[data-enquiry-drawer-retry]').hidden=true;
      refresh();
    };
    opener.addEventListener('click',event=>{
      if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      try{drawer.showModal();}catch(_){return;} // Leave the /cart link intact if modal activation fails.
      event.preventDefault();drawer.querySelector('[data-enquiry-drawer-close]').focus();loadDrawer();
    });
    drawer.querySelector('[data-enquiry-drawer-close]').addEventListener('click',()=>drawer.close());
    drawer.querySelector('[data-enquiry-drawer-retry]').addEventListener('click',loadDrawer);
    drawer.addEventListener('close',()=>{++readVersion;opener.focus();});
    drawer.addEventListener('cancel',()=>{++readVersion;});
    drawer.addEventListener('click',event=>{if(event.target===drawer)drawer.close();});
  }
  async function mutate(fn) {
    if(busy||sending)return;
    ++readVersion;busy=true;render();announce('Saving enquiry list…');
    try{
      if(!ready)throw Error('The enquiry list is unavailable.');
      const fresh=await read();
      if(!sameItems(items,fresh)){items=fresh;render();throw Error('Your list changed in another tab. Review it before retrying.');}
      const next=fn(fresh), value=serializeList(next);
      const returned=parseList((await api(next.length?value:'')).attributes?.[ATTRIBUTE]);
      if(!sameItems(returned,next))throw Error('The list save could not be confirmed.');
      items=await read();ready=true;render();
      announce(sameItems(items,next)?'Enquiry list updated.':'The list changed while saving. Review it before sending.',!sameItems(items,next));
    }catch(e){await refresh();announce(`${e.message} Review the list before retrying.`,true);}
    finally{busy=false;render();}
  }
  root?.querySelector('[data-enquiry-add]')?.addEventListener('click',()=>{
    const qty=root.querySelector('[data-enquiry-quantity]');
    let item;
    try{item={id:root.dataset.variantId,title:root.dataset.productTitle,sku:root.dataset.productSku,url:root.dataset.productUrl,quantity:quantity(qty.value)};}
    catch(e){announce(e.message,true);return;}
    mutate(current=>addItem(current,item));
  });
  const form=root?.querySelector('form');
  if(form){
    const message=root.querySelector('[data-enquiry-message]'), suburb=root.querySelector('[data-enquiry-suburb]');
    const restored=restoredDetails(message.value);message.value=restored.message;suburb.value=restored.suburb;
    message.addEventListener('input',()=>{try{render();}catch(e){announce(e.message,true);}});
    form.addEventListener('submit',async event=>{
      if(sending)return; // Allow the same native submission/hCaptcha continuation, never trigger another.
      event.preventDefault();
      if(busy||!ready){announce('Wait for the enquiry list to load.',true);return;}
      if(!form.reportValidity())return;
      try{
        busy=true;
        const fresh=await read();
        if(!sameItems(items,fresh)){items=fresh;render();throw Error('The list changed in another tab. Review it before sending.');}
        const payload=formatEnquiry(fresh,message.value,location.origin,suburb.value);
        // If browser session storage is blocked, do not submit without an attributable clear marker.
        sessionStorage.setItem(PENDING,JSON.stringify({path:location.pathname,time:Date.now(),items:fresh}));
        root.querySelector('[data-enquiry-body]').value=payload;
        sending=true;
        root.querySelector('[data-enquiry-send]').disabled=true;
        announce('Submitting once. If verification appears, complete it before trying again.');
        form.requestSubmit();
      }catch(e){announce(e.message,true);}
      finally{busy=false;}
    },true);
  }
  async function confirmed(){
    if(!root?.querySelector('[data-enquiry-confirmed]'))return;
    let pending;
    try{pending=JSON.parse(sessionStorage.getItem(PENDING)||'null');}catch(_){return;}
    if(!pending||pending.path!==location.pathname||Date.now()-pending.time>30*60*1000)return;
    sessionStorage.removeItem(PENDING);
    try{
      const current=await read();
      if(!sameItems(current,pending.items)){items=current;render();announce('Enquiry sent. The list changed and was retained for review.');return;}
      const returned=parseList((await api('')).attributes?.[ATTRIBUTE]);
      items=await read();render();
      announce(!returned.length&&!items.length?'Enquiry sent and list cleared.':'Enquiry sent; list could not be cleared. Review before sending another.',!!items.length);
    }catch(e){announce('Enquiry sent; the list could not be cleared. Review before sending another.',true);}
  }
  window.addEventListener('pageshow',()=>{if(!busy&&!sending)refresh().then(confirmed);});
  window.addEventListener('focus',()=>{if(!busy&&!sending)refresh();});
  refresh().then(confirmed);
})();
